import { defineComponent as _defineComponent } from 'vue'
import bugsnag from '../../global/bugsnag';
import globalData from '../../global/window-data';
import HeaderAccount from './menus/account/HeaderAccount.vue';
import HeaderCart from './menus/cart/HeaderCart.vue';
import HeaderLogo from './HeaderLogo.vue';
import HeaderNavigation from './HeaderNavigation.vue';
import Icon from 'JS/components/Icon.vue';
import MobileMenu from './menus/MobileMenu.vue';
import resourceService from '../../services/GlobalResourceService';
import SearchBar from './SearchBar.vue';
import { EventBusEvents } from 'Src/js/types/EventBus';
import { IBannerXAd } from 'JS/sponsored/sponsored-types';
import { IHeaderJson } from 'Src/js/types/Header';
import { IQuickCartSummaryJson } from 'Src/js/types/Order';
import { onBeforeMount, onMounted, ref } from 'vue';
import { useBreakpoints } from 'JS/composables/breakpoint';


export default /*#__PURE__*/_defineComponent({
  __name: 'Header',
  setup(__props) {

const headerData = ref<IHeaderJson>({} as IHeaderJson);
const megaMenuAd = ref<IBannerXAd>({} as IBannerXAd);
let hasFetchedMegaMenuAd = false;
let hasRecordedImpression = false;

const mobileMenuOpen = ref(false);
const openMobileMenuButton = ref<HTMLButtonElement | null>();

const { isDesktop } = useBreakpoints();

async function loadData() {
	try {
		const data = await resourceService.getHeaderData();
		headerData.value = data;

		window.vueEventBus?.$emit(EventBusEvents.UpdateQuickCart, data.cartSummaryJson);
	} catch (e) {
		bugsnag.notify(e);
	}
}

async function getMegaMenuAd() {
	if (!hasFetchedMegaMenuAd) {
		try {
			const data = await resourceService.getCategoryFlyoutAd();
			megaMenuAd.value = data;
		} catch (e) {
			bugsnag.notify(e);
		}

		hasFetchedMegaMenuAd = true;
	}
}

function recordAdImpression() {
	if (!hasRecordedImpression) {
		navigator.sendBeacon('/event/a/sponsored-ad-impression', JSON.stringify([megaMenuAd.value.adId]));
		hasRecordedImpression = true;
	}
}

function handleMobileMenuOpen() {
	mobileMenuOpen.value = true;

	window.blainGtmDataLayer.push({
		'menuName': "main",
		'event': "menu_open"
	});
}

function handleMobileMenuClose() {
	mobileMenuOpen.value = false;
	openMobileMenuButton.value.focus();
}

onBeforeMount(() => {
	try {
		if (typeof document === 'undefined') return;
		const header = document.getElementById("websiteHeader");
		headerData.value = JSON.parse(header.getAttribute('data-header-data'));

		window.addEventListener('pageshow', async (e) => {
			await loadData();
			const navigation = performance.getEntriesByType('navigation')[0];
			if (!navigation) {
				return;
			}
			if (e.persisted || ('PerformanceNavigationTiming' in window && navigation instanceof PerformanceNavigationTiming && navigation.type === 'back_forward')) {
				if (headerData.value.loggedIn !== !!globalData.customer) {
					window.location.reload();
				}
			}
		});

		window.vueEventBus.$on('header-vm', (data: IHeaderJson) => {
			headerData.value = data;
		});
		window.vueEventBus.$on(EventBusEvents.UpdateQuickCart, (cartSummary: IQuickCartSummaryJson) => {
			headerData.value.cartSummaryJson = cartSummary;
			headerData.value.itemsInCartCount = cartSummary.cartQty;
		});
	} catch (e) {
		bugsnag.notify(e);
	}
});

onMounted(() => {
	window.vueEventBus.$on(EventBusEvents.LoginSuccess, loadData);
});


return { __sfc: true,headerData, megaMenuAd, hasFetchedMegaMenuAd, hasRecordedImpression, mobileMenuOpen, openMobileMenuButton, isDesktop, loadData, getMegaMenuAd, recordAdImpression, handleMobileMenuOpen, handleMobileMenuClose, HeaderAccount, HeaderCart, HeaderLogo, HeaderNavigation, Icon, MobileMenu, SearchBar }
}

})